<div class="small-top-margin">
  <ng-container>
    <ng-container>
        <div class="fileupload-module input" [class.fileupload-module-error]="hasError">
        <div class="fileupload vertical-center" appDnd (fileDropped)="submitFileUpload($event)">
          <img class="upload-image" src="../../../assets/img/form/upload.svg" alt="upload">
          <span class="drag-n-drop-text-default">{{'file.dragNDrop.default'|translate}}</span>
          <span class="drag-n-drop-text-ok">{{'file.dragNDrop.ok'|translate}}</span>
          <span class="drag-n-drop-text-error">{{'file.dragNDrop.error'|translate}}</span>
          <label class="button get-upload-file flex justify-content-center">
            <input #fileInput (change)="submitFileUpload($any($event.target).files, fileInput)"
                   class="display-none"
                   id="file" type="file"
                   [accept]="ACCEPTED_FILE_TYPES">{{'file.search'|translate}}
          </label>
        </div>
      </div>
    </ng-container>

    <ng-container>
      <div *ngFor="let fileUploadStatus of fileUploadStatusOfComponent$ | async; let i = index">
        <app-upload-container [fileUploadStatus]="fileUploadStatus"
                              [callbackDeleteFileUploadStatus]="deleteFileUploadStatusFromFrontendOnly.bind(this)"
                              [retryFileUploadCallback]="retryFileUpload.bind(this)"
        ></app-upload-container>

      </div>
    </ng-container>
  </ng-container>
</div>
